import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit, Renderer2 } from '@angular/core';

import {Router} from '@angular/router';
import {RestapiService} from '../restapi.service';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.css']
})
export class AdminComponent implements OnInit {
  anio: number = new Date().getFullYear();
  userName = "User"
  showSubmenu: boolean = false;

  constructor(@Inject(DOCUMENT) private document: Document,
        private renderer: Renderer2,private router: Router, private _rest: RestapiService) { 
  }

  ngOnInit(): void {
    if(localStorage.getItem('userName')!= undefined){
      this.userName = localStorage.getItem('userName');
    }
  }
  sideNavToggle(){
    if(document.getElementsByTagName("body")[0].className.match(/open/)){
      this.renderer.removeClass(this.document.body, 'open');
    } else {
      this.renderer.addClass(this.document.body, 'open');
    }
  }
  ddToggleMenu(){
    if(document.getElementById("ddLogout").className.match(/show/)){
      this.renderer.removeClass(document.getElementById("ddMenu"), 'show');
      this.renderer.removeClass(document.getElementById("ddLogout"), 'show');
    } else {
      this.renderer.addClass(document.getElementById("ddMenu"), 'show');
      this.renderer.addClass(document.getElementById("ddLogout"), 'show');
    }
  }

  menuSubmenu(myid){

    if(document.getElementById(myid).className.match(/show/)){
      this.renderer.removeClass(document.getElementById(myid), 'show');
      this.renderer.removeClass(document.getElementById("sub"+myid), 'show');
      //this.renderer.setAttribute(document.getElementsByClassName("a"+myid), "aria-expanded", "false");
    } else {
      this.renderer.addClass(document.getElementById(myid), 'show');
      this.renderer.addClass(document.getElementById("sub"+myid), 'show');
      //this.renderer.setAttribute(document.getElementsByClassName("a"+myid), "aria-expanded", "false");
    }

  }

  glogout() {
    localStorage.clear();
    this.router.navigate(['/']);
  }
  gochgPsw(){
    this.router.navigate(['admin/changepassword']);
    
  }
  opensnack(){
    var lastAct = parseInt(localStorage.getItem('lastAct'));
     if (lastAct !== null && lastAct !== undefined) {
      var d = new Date();
      var  curTime = d.getTime();
      if(lastAct > curTime){
        localStorage.setItem('lastAct', (curTime+(10*1000)).toString());
      } else {
        localStorage.clear();
        this.router.navigate(['/']);
        return false;
      }
      
     } else {
      localStorage.clear();
      this.router.navigate(['/']);
      return false;
    }
  }
  ngOnDestroy(): void {
    this.renderer.removeClass(this.document.body, 'open');
  }

}
